import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Profile } from '../../models';

export interface ProfileUpdateRequest {
  nombreCompleto: string;
  cedulaProfesional: string;
  especialidad: string;
}

@Injectable({ providedIn: 'root' })
export class ProfileApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/v1`;

  getProfile$(): Observable<Profile> {
    return this.http.get<Profile>(`${this.baseUrl}/profile`);
  }

  getProfile(): Promise<Profile> {
    return firstValueFrom(this.getProfile$());
  }

  updateProfile$(body: ProfileUpdateRequest): Observable<Profile> {
    return this.http.put<Profile>(`${this.baseUrl}/profile`, body);
  }

  updateProfile(body: ProfileUpdateRequest): Promise<Profile> {
    return firstValueFrom(this.updateProfile$(body));
  }
}
